// Shared control chrome for every text input, textarea and select - see
// NewCase.css's .rma-nc-control rules.
export function controlClasses(size, className) {
  return ["rma-nc-control", "rma-nc-control--" + size, className]
    .filter(Boolean)
    .join(" ");
}
